import styled from "styled-components";

const StyledStepAtiva = styled.div`
  background-color: #0f2047;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center; /* Corrigido aqui */
  font-size: 12px;
  color: #fff;
`;
const StepAtiva = ({ label }) => {
  return (
    <StyledStepAtiva>
      {label}
    </StyledStepAtiva>
  );
};

export default StepAtiva;
